<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/manage_role/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div
      class="w100"
      v-if="
        typeof manage_list === 'object' && Object.keys(manage_list).length > 0
      "
    >
      <!-- {{ staff_type }} -->
      <table class="table">
        <thead>
          <tr>
            <th class="">管理権限名</th>
            <th colspan="2">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in manage_list" :key="list.id">
            <td>{{ list.label }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'ManageListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '管理権限一覧',
      fromParentBtn: '管理権限登録',
      manage_role_obj: [],
      manage_account_level: [
        {
          key: 0,
          label: '管理者'
        },
        {
          key: 10,
          label: '制限'
        }
      ]
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({
      // manage_account_level: state => state.apidata.manage_account_level
    }),
    manage_list: function () {
      const lists = [...this.manage_role_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    get_level_label: function () {
      const manage_account_level = this.manage_account_level
      return function (key) {
        if (
          manage_account_level.find(type => {
            return type.key == key
          })
        ) {
          return manage_account_level.find(type => {
            return type.key == key
          }).label
        }
        return '-'
      }
    }
  },

  async created() {
    // await this.loadManageAccountLevel()
    await this.loadManageList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '管理者一覧データです。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.manage_role_obj.find(manage => {
          return manage.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'manage_role' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadManageList()
          })
      }
    },
    async loadManageList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/manage_role/lists',
        params
      )
        .then(async response => {
          console.log('loadManageList response', response)
          this.manage_role_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.manage_role_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    // async loadManageAccountLevel() {
    //   // console.log('tag');
    //   return this.$store
    //     .dispatch('fetchBasicLists', {
    //       data: {},
    //       target: 'manage_account_level'
    //     })
    //     .catch(err => Promise.reject(err))
    //     .then(() => {})
    //     .finally(() => {})
    // },
    handleClick(target) {
      this.$router.push({ path: '/manage_role/' + target + '/' })
    }
  }
}
</script>
